import { render, staticRenderFns } from "./ImageClip.vue?vue&type=template&id=0131eec0&scoped=true&"
import script from "./ImageClip.vue?vue&type=script&lang=js&"
export * from "./ImageClip.vue?vue&type=script&lang=js&"
import style0 from "./ImageClip.vue?vue&type=style&index=0&id=0131eec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131eec0",
  null
  
)

export default component.exports